import { FC } from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import "./style.css";
import { selectMainState } from "../../store/slices/main";
import { useAppSelector } from "../../hooks/redux-hooks";
import { Link } from "react-router-dom";

type IProps = {
  deviceType: string;
};

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 720 },
    items: 1,
    paritialVisibilityGutter: 0,
  },
  table: {
    breakpoint: { max: 720, min: 448 },
    items: 1,
    paritialVisibilityGutter: 0,
  },
  mobile: {
    breakpoint: { max: 448, min: 0 },
    items: 1,
    paritialVisibilityGutter: 0,
  },
};

const Slider: FC<IProps> = ({ deviceType }) => {
  const { addsSliderHomePage } = useAppSelector(selectMainState);

  return (
    <div className="min-h-[10rem] pt-6 px-5 bg-white relative md:min-h-[1rem] md:pt-0 md:px-0">
      {/* <div className="min-h-[10rem] pt-6 px-5 bg-white relative md:min-h-[15.8rem] md:max-h-[15.7rem] md:mt-5"> */}
      {addsSliderHomePage && (
        <Carousel
          className="max-w-screen min-h-[6.9rem] max-h-min flex items-center rounded-md md:max-h-[17.2rem] overflow-hidden"
          partialVisbile
          deviceType={deviceType}
          itemClass="image-item"
          responsive={responsive}
          removeArrowOnDeviceType={["desktop", "tablet", "mobile"]}
          showDots={true}
          infinite={true}
          autoPlay={true}
          autoPlaySpeed={5000}
          renderDotsOutside
        >
          {addsSliderHomePage?.map((slide) => {
            return (
              <Link to={slide.link} target="_blank">
                <div
                  key={slide.id}
                  className="w-full h-full flex justify-center items-center overflow-hidden rounded-md"
                >
                  <img
                    src={`${
                      deviceType === "desktop"
                        ? slide.desktopImgPath
                        : slide.mobileImgPath
                    }`}
                    alt={slide.imgAlt || "img"}
                    className="w-full h-full object-cover shadow-lg"
                  />
                </div>
              </Link>
            );
          })}
        </Carousel>
      )}
    </div>
  );
};

export default Slider;
